(function() {
  'use strict';

  angular.module('app.ckadmin', []);
})();
